import React from "react";
import NotFoundContainer from "../containers/NotFound";

const NotFound = () => {
    return (
        <NotFoundContainer />
    )
}

export default NotFound;